import React from "react";
import chendur from "../../assets/clientLogos/Chendur.png";
import cqf from "../../assets/clientLogos/CQF.png";
import dotzen from "../../assets/clientLogos/DotZen.png";
import gowsan from "../../assets/clientLogos/Gowsan.png";
import kalirajiasacademy from "../../assets/clientLogos/KalirajIASAcademy.jpg";
import kasiram from "../../assets/clientLogos/Kasiram.png";
import lakshana from "../../assets/clientLogos/Lakshana.png";
import mildanaturals from "../../assets/clientLogos/Milda_Naturals_Logo_New.png";
import rajusclasses from "../../assets/clientLogos/Raju's Classes.png";
import raysofflix from "../../assets/clientLogos/RaysOfFlix.png";
import rcm from "../../assets/clientLogos/RotaryClubOfMadras.png";
import samporto from "../../assets/clientLogos/Samporto.png";
import selvasiasacademy from "../../assets/clientLogos/Selva's_IAS_Academy_Logo.png";
import sreekrishnaplayschool from "../../assets/clientLogos/SreeKrishnaPlaySchool.png";
import twiwatches from "../../assets/clientLogos/TWI Watches - Brain Mask.jpg";
import twinstarindustries from "../../assets/clientLogos/Twinstar.png";
import cbcid from "../../assets/clientLogos/CBCID.jpg";
import ssbtLogo from "../../assets/clientLogos/SSBT_LOGO.png";
import ariesDescLogo from "../../assets/clientLogos/AriesDec_Golbal_logo.png";

const brands = [
  ariesDescLogo,
  ssbtLogo,
  cbcid,
  chendur,
  cqf,
  dotzen,
  gowsan,
  kalirajiasacademy,
  kasiram,
  lakshana,
  mildanaturals,
  rajusclasses,
  raysofflix,
  rcm,
  samporto,
  selvasiasacademy,
  sreekrishnaplayschool,
  twiwatches,
  twinstarindustries,
];

export default function ClientTestimonials() {
  return (
    <section className="bg-gray-50 py-16 px-6 md:px-12 lg:px-24">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <p className="text-gray-500 text-sm font-medium mb-3">Our Clients</p>
        <hr className="mb-6 border-gray-200" />
        <h2 className="text-3xl md:text-5xl font-serif font-medium text-gray-900 mb-6 leading-snug">
          Trusted by ambitious leaders and <br /> forward-thinking
          organizations.
        </h2>
        <p className="text-gray-600 text-lg max-w-3xl mb-12">
          We’ve partnered with diverse clients — from startups and institutions
          to industrial companies — delivering impactful digital and software
          solutions that drive results.
        </p>

        {/* Smooth Marquee Section */}
        <section className="py-12 bg-[#f7f5f2]">
          <div className="max-w-7xl mx-auto px-4 text-center">
            <h2 className="text-sm uppercase text-gray-500 tracking-widest mb-4">
              Trusted by the world’s best companies
            </h2>

            {/* Marquee Container */}
            <div className="overflow-hidden relative">
              <div className="flex gap-10 md:gap-16 animate-marquee">
                {[...Array(2)].map((_, index) => (
                  <div key={index} className="flex gap-10 md:gap-16 shrink-0">
                    {brands.map((logo, i) => (
                      <div
                        key={i}
                        className="h-20 w-28 md:h-24 md:w-36 bg-white rounded-xl flex items-center justify-center shadow-sm border border-gray-100"
                      >
                        <img
                          src={logo}
                          alt={`Brand ${i + 1}`}
                          className="max-h-16 md:max-h-20 object-contain"
                        />
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>
      </div>
    </section>
  );
}
